module.exports = __webpack_public_path__ + "img/win-icon1.9039855.png";